import React, { useEffect, useState } from "react";
import "../App.css";
import { Auth } from "aws-amplify";
import { Navigate } from "react-router-dom";

function Account(props) {
  const [user, setUser] = useState();
  const [isLoading, setIsLoading] = useState(true);

  async function getCurrentUser() {
    try {
      const authUser = await Auth.currentAuthenticatedUser();
      setUser(authUser);
    } catch (e) {
      setUser(null);
      setIsLoading(false);
    }
  }

  async function deleteUser() {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete your account?"
    );

    if (confirmDelete) {
      try {
        await Auth.deleteUser();
      } catch (error) {
        console.log("error deleteUser: ", error);
      }
      setUser(null);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getCurrentUser();
  }, []);

  async function handleSignOut(event) {
    event.preventDefault();
    try {
      await Auth.signOut();
    } catch (error) {
      console.log("error signing out: ", error);
    }
    setUser(null);
    setIsLoading(false);
  }

  if (!user && !isLoading) {
    return <Navigate to="/" replace={true} />;
  }

  return (
    <div className="account">
      <header className="account-header">
        <h1>Account</h1>
        <button onClick={handleSignOut} className="ui button blue">
          Log Out
        </button>
      </header>
      <main className="account-content">
        <p className="app-text">
          After deleting your account, your are not able to access it anymore.
          <br />
        </p>
        <div className="button-row">
          <button className="ui button blue" onClick={() => deleteUser()}>
            Delete Account
          </button>
        </div>
      </main>
    </div>
  );
}

export default Account;
